import React, { FC } from 'react';

import { UseQueryResult } from '@tanstack/react-query';
import classNames from 'classnames';

import { EvSection, TABLE_SR_SUMMARY_IDS } from '@evinced-private/ui-common';

import { MOBILE_SDK_DASHBOARD_PAGE_TABLE_SECTION_ID } from 'data-automation-ids/MobileSdkDashboardAutomationIds';
import { TMobileSdkTestsResult } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { PlatformTable } from 'src/common/components/platform-table/PlatformTable';
import { MOBILE_SDK_TESTS_TABLE_ID } from 'src/common/pages/dashboards-container/dashboard_consts';

import { getMobileSdkTestsColumns, PLATFORM_TABLE_OPTIONS } from './MobileSdkTestsTableHelper';

import './MobileSdkTestsTable.scss';

interface IMobileSdkDashboardTableProps {
	testsQuery: UseQueryResult<TMobileSdkTestsResult>;
	unfilteredTotal: number;
}

export const MobileSdkTestsTable: FC<IMobileSdkDashboardTableProps> = ({
	testsQuery,
	unfilteredTotal
}) => {
	const total: number = testsQuery.data?.total ?? 0;

	const isTableLoading =
		testsQuery.isLoading ||
		testsQuery.isPreviousData ||
		(testsQuery.isStale && testsQuery.isRefetching);

	return (
		<EvSection
			ariaLabel="Mobile SDK tests table"
			ariaLive="polite"
			ariaDescribedby={TABLE_SR_SUMMARY_IDS}
			skipLinkId="main-section"
			className={classNames('dashboard-section', 'mobile-sdk-tests-table')}
			dataAutomationId={MOBILE_SDK_DASHBOARD_PAGE_TABLE_SECTION_ID}
		>
			<PlatformTable
				isTableLoading={isTableLoading}
				tableId={MOBILE_SDK_TESTS_TABLE_ID}
				tableData={testsQuery.data?.rows}
				totalPaginationableResults={total}
				totalCount={unfilteredTotal}
				persistTableState
				columns={getMobileSdkTestsColumns()}
				options={PLATFORM_TABLE_OPTIONS}
			/>
		</EvSection>
	);
};
